export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL || "https://memory-snap.eu-central-1.linodeobjects.com"
